import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { GlobalProvider } from "./GlobalState";

import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";

import { AuthProvider } from "./auth/AuthProvider";

const history = createBrowserHistory();

ReactDOM.render(
  <AuthProvider>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </Router>
      </PersistGate>
    </Provider>
  </AuthProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
